<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-09 16:33:44
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-09 16:33:44
 * @FilePath: \vue-privilege-routing\src\pages\system\system-develop\index.vue
-->
<template>
    <div>
       系统开发
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
